import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";

/**
 * Pull the queue and its stat cards back from the server after a write. The grid
 * and the cards read the same filtered set, so they always have to refresh
 * together — a refetch of one leaves the other lying about the same rows.
 */
export function useRefetchWorkQueue(): () => void {
  const apolloClient = useApolloClient();
  return useCallback(() => {
    void apolloClient.refetchQueries({ include: ["UnifiedWorkItems", "UnifiedWorkStats"] });
  }, [apolloClient]);
}
